import React from 'react'
import 'antd/dist/antd.css';
import sad from "../lf3/sad.png"
import { Card } from 'antd';
import {Col,Row } from "antd";

export default function NotEligible({partnerName}) {
  return (
<Row style={{textAlign:"center",justifyContent:"center"}}>
<Card style={{ backgroundColor:"#FFFFFF",
                height:"254.5px",
                width:"335px",
                borderRadius:"10px",
              }}>
    <div style={{textAlign:"center",
    marginTop:"20px"
    }}>
   <img src={sad} style={{height:"78.5px",width:"78.5px"}} />
   </div>
   <Col style={{color:"#000000",fontWeight:"bold",fontSize:"18px",textAlign:"center"}}>You are not eligible</Col>
   <Col style={{color:"8C8C8C",fontSize:"15px",textAlign:"center"}}>We have done a background check, <br/>you are not elibile for {partnerName} </Col>
  </Card>
  </Row>
  );
}
